export default __webpack_public_path__ + "static/media/mens-clothing.bc0c7789.jpg";